@defer {
    <footer id="main_footer" class="bg-[#F2F2F6] select-none">
        <div class="container flex justify-between mx-auto px-4 max-w-[1280px]">
            <div class="flex items-center justify-center w-full gap-2 py-6 md:justify-end">
                <button
                    (click)="connectKakao()"
                    class="bg-[#FEE500] flex gap-2 items-center justify-center py-2 rounded-xl h-10 w-full max-w-[160px] hover:bg-opacity-60 active:bg-opacity-80"
                >
                    <p class="text-sm font-semibold text-gray-800">상담하기</p>
                    <img [draggable]="false" class="md:size-5 size-3.5 w-fit" src="icons/kakao_logo.svg" />
                </button>
                <button
                    routerLink="/customer"
                    class="bg-white flex gap-2 items-center justify-center py-2 rounded-xl h-10 w-full max-w-[160px] hover:bg-opacity-60 active:bg-opacity-80"
                >
                    <p class="text-sm font-semibold text-gray-800">고객센터</p>
                </button>
            </div>
        </div>
        <div class="border-b border-gray-200"></div>
        <div class="container flex justify-between mx-auto px-4 max-w-[1280px]">
            <div class="flex flex-col w-full gap-4 py-7">
                <div class="flex items-center justify-between w-full">
                    <p class="font-semibold text-gray-500">
                        {{ businessInfo()?.name }}
                    </p>
                    <div class="flex items-center gap-2 pr-10 *:size-7 *:cursor-pointer transition-all">
                        <a
                            class="hover:opacity-80"
                            target="_blank"
                            href="https://www.instagram.com/greentravel607/profilecard/?igsh=MTA3eW13cXZpdGgxNg=="
                        >
                            <img [draggable]="false" src="icons/instagram.svg" />
                        </a>
                        <a class="hover:opacity-80" (click)="connectKakao()">
                            <img [draggable]="false" src="icons/kakao.svg" />
                        </a>
                        <a class="hover:opacity-80" target="_blank" href="https://band.us/band/72321860">
                            <img [draggable]="false" src="icons/bing.svg" />
                        </a>
                    </div>
                </div>
                <div class="flex md:flex-row flex-col gap-2 *:font-semibold text-sm *:cursor-pointer md:items-center">
                    <!-- 약관 -->
                    <div class="flex flex-col gap-2 md:flex-row">
                        <div class="flex items-center gap-2">
                            @for (term of termTypeList.slice(0, 3); track $index) {
                                <a
                                    [routerLink]="['/', 'policy', term.key]"
                                    class="text-xs text-gray-500 transition-all md:text-sm hover:opacity-80"
                                >
                                    {{ term.value }}
                                </a>
                                <div
                                    [ngClass]="
                                        $index === 2 ? 'hidden md:block h-4 border-r border-gray-200' : 'h-4 border-r border-gray-200'
                                    "
                                ></div>
                            }
                        </div>
                        <div class="flex items-center gap-2">
                            @for (term of termTypeList.slice(3, 5); track $index) {
                                <a
                                    [routerLink]="['/', 'policy', term.key]"
                                    class="text-xs text-gray-500 transition-all md:text-sm hover:opacity-80"
                                >
                                    {{ term.value }}
                                </a>

                                <div [ngClass]="$index === 1 ? 'hidden' : 'h-4 border-r border-gray-200'"></div>
                            }
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <div class="flex flex-col lg:flex-row lg:items-center gap-2 *:md:text-sm *:text-xs">
                        <p class="text-gray-500">대표자명 : {{ businessInfo()?.ceoName }}</p>
                        <p class="text-gray-500">주소 : {{ businessInfo()?.address }}</p>
                    </div>
                    <div class="flex flex-col lg:flex-row lg:items-center gap-2 *:md:text-sm *:text-xs">
                        <p class="text-gray-500">고객센터 : {{ businessInfo()?.tel | tel }}</p>
                    </div>
                    <div class="flex flex-col md:flex-row md:items-center gap-2 *:md:text-sm *:text-xs">
                        <p class="text-gray-500">사업자 등록번호 : {{ businessInfo()?.businessLicenseNumber }}</p>
                        <p class="text-gray-500">통신판매업 번호 : {{ businessInfo()?.onlineSaleNumber }}</p>
                    </div>
                    <p class="text-xs text-gray-500 md:text-sm">
                        관광 사업자 등록번호 :
                        {{ businessInfo()?.tourismBusinessNumber }}
                    </p>
                </div>
                <!-- <p class="text-xs text-gray-500 md:text-sm">COPYRIGHT (C) 2024 Tour Green tour ALL RIGHT RESERVED</p> -->
                <p class="text-xs text-gray-500 md:text-sm">COPYRIGHT (C) {{ businessInfo()?.copyright }}</p>
            </div>
            <div class="flex flex-col gap-6 py-7">
                <div
                    (click)="connectKakao()"
                    class="flex items-center hover:opacity-80 transition-all justify-center p-2 bg-[#FEE500] rounded-full cursor-pointer"
                >
                    <img [draggable]="false" class="block size-7" src="icons/kakao_logo.svg" />
                </div>
                <div (click)="scrollToTop()" class="flex items-center justify-center p-2 bg-white rounded-full cursor-pointer">
                    <lepi-icon name="solar:arrow-up-linear" class="block bg-gray-500 size-7"></lepi-icon>
                </div>
            </div>
        </div>
    </footer>
}
